import React, { useContext, useEffect, useState } from "react";
import ICatalog_Item from "../../../../models/ICatalog_Item";
import styled from "styled-components";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOnTypeaheadCatalogItemDTO from "../../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import ITypeaheadCatalogItemDTO from "../../../../models/DTO/ITypeaheadCatalogItemDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOnGetChildItemsDTO from "../../../../models/DTO/IOnGetChildItemsDTO";
import IGetChildItemsDTO from "../../../../models/DTO/IGetChildItemsDTO";
import ICatalog_Item_Child_Item_MapUI from "../../../../models/ICatalog_Item_Child_Item_MapUI";
import { OwIconButton } from "../../../shared/OwIconButton/OwIconButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { Socket } from "socket.io-client";

type Props = {
    parentCatalogItem: ICatalog_Item;
    socket: Socket;
    catalogGuid: string;
    updateChildItems: (mapItems: ICatalog_Item_Child_Item_MapUI[]) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

const CatalogItemChildItemDetailDiv = styled.div`
    margin-top: 2rem;
`;

const ItemLookup = styled.div`
    display: flex;
    width: 100%;
`;

const ChildItemsDiv = styled.div``;

interface IChildItemsUI {
    item: ICatalog_Item;
    deleteFlag: boolean;
    existingItem: boolean;
}

export const CatalogItemChildItemDetail: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [foundItems, setFoundItems] = useState<ICatalog_Item[]>([]);
    const [selectedItem, setSelectedItem] = useState<ICatalog_Item | null>(null);
    const [childItems, setChildItems] = useState<IChildItemsUI[]>([]);

    useEffect(() => {
        props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, onTypeaheadCatalogItem);
        props.socket.on(EndpointsEnum.CatalogItemOnGetChildItems, onGetChildItems);

        if (props.parentCatalogItem.id) {
            getChildItems();
        }

        return () => {
            props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, onTypeaheadCatalogItem);
            props.socket.removeListener(EndpointsEnum.CatalogItemOnGetChildItems, onGetChildItems);
        };
    }, []);

    useEffect(() => {
        // update in the main sidebar
        const updatedChildItems: ICatalog_Item_Child_Item_MapUI[] = [];

        if (childItems) {
            for (const childItem of childItems) {
                const mapItem: Partial<ICatalog_Item_Child_Item_MapUI> = {
                    parent_catalog_item_id: props.parentCatalogItem.id,
                    child_catalog_item_id: childItem.item.id,
                    deleteFlag: childItem.deleteFlag,
                };

                if (mapItem.deleteFlag) {
                    if (childItem.existingItem) {
                        updatedChildItems.push(mapItem as ICatalog_Item_Child_Item_MapUI);
                    }
                } else {
                    updatedChildItems.push(mapItem as ICatalog_Item_Child_Item_MapUI);
                }
            }

            props.updateChildItems(updatedChildItems);
        }
    }, [childItems]);

    useEffect(() => {
        if (selectedItem) {
            let exists = false;

            for (const childItem of childItems) {
                if (childItem.item.id === selectedItem.id) {
                    exists = true;
                }
            }

            if (exists) {
                const notification: INotification = {
                    message: "item_already_exists_as_child",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                };
                // notify user?
                props.notifyFn(null, notification);
            } else {
                let existingChildItems: IChildItemsUI[] = [
                    {
                        item: selectedItem,
                        deleteFlag: false,
                        existingItem: false,
                    },
                ];

                console.log("existingChildItems", existingChildItems);

                console.log("childItems", childItems);
                if (childItems) {
                    existingChildItems = [...existingChildItems, ...childItems];
                }

                console.log("existingChildItems", existingChildItems);

                setChildItems(existingChildItems);
            }
        }
    }, [selectedItem]);

    const getChildItems = () => {
        const payload: IGetChildItemsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            parentCatalogItemId: props.parentCatalogItem.id,
        };

        props.socket.emit(EndpointsEnum.CatalogItemGetChildItems, payload);
    };

    const onGetChildItems = (data: IOnGetChildItemsDTO) => {
        const _childItems = data.childItems.map((item) => {
            return {
                item,
                deleteFlag: false,
                existingItem: true,
            };
        });

        setChildItems(_childItems);
    };

    const doItemLookup = (name: string) => {
        const payload: ITypeaheadCatalogItemDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogGuid: props.catalogGuid,
            name,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    const onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        setFoundItems(data.catalog_items);
    };

    const selectedChildItemFn = (item: ICatalog_Item) => {
        setSelectedItem(item);
    };

    const deleteChildItem = (childItem: { item: ICatalog_Item; deleteFlag?: boolean }) => {
        const existingChildItems = [...(childItems || [])];

        for (const _childItem of existingChildItems) {
            if (_childItem.item.id === childItem.item.id) {
                _childItem.deleteFlag = true;
            }
        }

        setChildItems(existingChildItems);
    };

    return (
        <CatalogItemChildItemDetailDiv>
            <div className={"bd-callout"}>
                <OwLabel title={"child_items"} leftIconClass={"fa-duotone fa-shapes"} isBold={true} />
            </div>
            <ItemLookup>
                <Typeahead
                    isSelectableFn={() => {
                        return true;
                    }}
                    typeaheadApiFn={doItemLookup}
                    typeaheadItems={foundItems}
                    titleProp={"name"}
                    subTitleProp={"sku"}
                    selectedItemFn={selectedChildItemFn}
                    confirmAdd={true}
                    scrollableList={true}
                    outerWrapperClassName={"w-100 mb-2"}
                    placeholder={"search_catalog_items"}
                />
            </ItemLookup>

            <ChildItemsDiv>
                {childItems.map((childItem) => {
                    if (childItem.deleteFlag) {
                        return null;
                    } else {
                        return (
                            <div key={childItem.item.guid}>
                                <OwIconButton
                                    iconClass={"text-danger"}
                                    iconColorClass={"fad fa-trash-alt"}
                                    fn={() => {
                                        deleteChildItem(childItem);
                                    }}
                                />{" "}
                                {childItem.item.name} - {childItem.item.sku}
                            </div>
                        );
                    }
                })}
            </ChildItemsDiv>
        </CatalogItemChildItemDetailDiv>
    );
};
